import { Button, Modal } from 'antd';

export default function TrendModal({
  show,
  children,
  onCancel,
  onAddClick,
  hasBtn,
  title,
  width,
  maskClosable = true,
}) {
  return (
    <Modal
      maskClosable={maskClosable}
      className="rounded-[30px] overflow-hidden bg-white"
      title={title || 'Parameters'}
      width={width || 300}
      styles ={{ background: '#FDFDFD', padding: '0 0 15px 0' }}
      visible={show}
      footer={null}
      onCancel={onCancel}
    >
      <div className="flex  flex-col items-center justify-center">
        {children}
        {!hasBtn && (
          <Button
            onClick={onAddClick}
            className="rounded-xl  text-center w-36 h-9 text-xs text-white bg-[#6E6FF7]"
          >
            Add Parameters
          </Button>
        )}
      </div>
    </Modal>
  );
}
